import { heroTopics } from "@/mocks/guaData";

export default function Hero() {
  const go = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-primary-100/70 blur-2xl"></div>
      <div className="pointer-events-none absolute -bottom-20 -left-24 h-72 w-72 rounded-full bg-accent-100/70 blur-2xl"></div>

      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1.15fr_0.85fr]">
        <div>
          <p className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="live-dot absolute inline-flex h-full w-full rounded-full bg-primary-500"></span>
            </span>
            今日吃瓜现场实时更新中
          </p>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-950 sm:text-4xl md:text-5xl">
            今天大家在
            <span className="relative mx-1 text-primary-600">
              看什么瓜
              <span className="absolute -bottom-1 left-0 h-2 w-full rounded bg-accent-200"></span>
            </span>
            ？
          </h1>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            每日有瓜是吃瓜群众的聚集地：讨论区、评论区、吃瓜现场实时更新，点开就能看到大家怎么看、热议什么。加入吃瓜现场，一起聊聊今天最热的那口瓜。
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <button
              onClick={() => go("today")}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 shadow-sm transition hover:bg-primary-600"
            >
              围观今日热点
              <i className="ri-arrow-right-line text-base"></i>
            </button>
            <button
              onClick={() => go("faq")}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-book-open-line text-base"></i>
              吃瓜百科
            </button>
          </div>

          <dl className="mt-9 grid grid-cols-3 gap-4 border-t border-background-200 pt-6 sm:max-w-md">
            {[
              { n: "24.8 万", l: "今日参与讨论" },
              { n: "326", l: "实时热议现场" },
              { n: "6.2 千", l: "累计热门话题" },
            ].map((s) => (
              <div key={s.l}>
                <dt className="order-2 mt-1 text-xs text-foreground-500">{s.l}</dt>
                <dd className="order-1 font-display text-2xl text-primary-600">{s.n}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative mx-auto w-full max-w-md lg:max-w-none">
          <div className="floaty relative overflow-hidden rounded-2xl border border-background-200 bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20coral%20and%20amber%20flat%20illustration%20of%20a%20group%20of%20young%20diverse%20people%20sitting%20together%20chatting%20excitedly%20while%20looking%20at%20their%20phones%2C%20speech%20bubbles%20floating%20above%20them%2C%20a%20watermelon%20and%20popcorn%20snacks%20on%20the%20low%20table%2C%20cozy%20evening%20neighborhood%20vibe%2C%20soft%20shadows%2C%20minimal%20background%2C%20no%20text%2C%20playful%20editorial%20style&width=960&height=760&seq=hero-gua-01&orientation=portrait&nocache=true"
              alt="一群吃瓜群众围坐聊天看手机的场景插画"
              className="h-full w-full object-cover"
              width="960"
              height="760"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/10 to-transparent"></div>
          </div>

          <div className="absolute -left-3 top-6 hidden rounded-xl border border-background-200 bg-background-50 px-3 py-2 shadow-sm sm:block">
            <p className="text-xs font-medium text-primary-600">🔥 3.2 千人在围观</p>
          </div>
          <div className="absolute -right-2 bottom-16 hidden rounded-xl border border-background-200 bg-background-50 px-3 py-2 shadow-sm sm:block">
            <p className="text-xs font-medium text-accent-700">💬 刚刚新增 66 条评论</p>
          </div>
        </div>
      </div>

      <div className="relative border-y border-background-200/80 bg-background-100/80">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 flex items-center bg-gradient-to-r from-background-50 via-background-50/70 to-transparent px-4">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
            <i className="ri-fire-line"></i> 正在吃瓜
          </span>
        </div>
        <div className="ticker-track items-center gap-0 py-3 pl-40">
          {[...heroTopics, ...heroTopics].map((t, i) => (
            <span
              key={i}
              className="inline-flex items-center whitespace-nowrap text-sm text-foreground-700"
            >
              <span className="mx-5 inline-flex items-center gap-1.5">
                <span className="rounded bg-accent-100 px-1.5 py-0.5 text-xs text-accent-700">{t.tag}</span>
                {t.title}
              </span>
              <i className="ri-fire-fill text-primary-400"></i>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}